import React from 'react';
import PropTypes from 'prop-types';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import { X } from 'lucide-react';

export function ProcessorStep4Marketing({
  formData,
  handleInputChange,
  productTypes,
  newProduct,
  setNewProduct,
  addProduct,
  removeProduct,
}) {
  return (
    <div className="space-y-6">
      <h3 className="text-xl font-semibold text-orange-900 border-b-2 border-orange-200 pb-2">
        Marketing & Sales
      </h3>
      <div className="grid md:grid-cols-2 gap-4">
        <div className="col-span-2">
          <Label>Products Sold</Label>
          <div className="space-y-3">
            <div className="flex gap-2">
              <Input
                value={newProduct}
                onChange={(e) => setNewProduct(e.target.value)}
                placeholder="Enter product type (e.g., Tableya, Chocolate bars)"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    e.stopPropagation();
                    addProduct();
                  }
                }}
              />
              <Button type="button" onClick={addProduct} variant="outline">
                Add
              </Button>
            </div>
            <div className="flex flex-wrap gap-2">
              {productTypes.map((product, index) => (
                <Badge key={index} variant="secondary" className="flex items-center gap-1">
                  {product}
                  <button
                    type="button"
                    onClick={() => removeProduct(product)}
                    className="ml-1 hover:text-red-600"
                  >
                    <X className="h-3 w-3" />
                  </button>
                </Badge>
              ))}
            </div>
          </div>
        </div>
        
        <div>
          <Label htmlFor="marketing">Marketing Strategy</Label>
          <Input
            id="marketing"
            value={formData.marketing}
            onChange={(e) => handleInputChange('marketing', e.target.value)}
            placeholder="e.g., Yes, No"
          />
        </div>
        
        <div>
          <Label htmlFor="typeOfMarketing">Type of Marketing</Label>
          <Input
            id="typeOfMarketing"
            value={formData.typeOfMarketing}
            onChange={(e) => handleInputChange('typeOfMarketing', e.target.value)}
            placeholder="e.g., Retail, Wholesale, Retail and whole sale"
          />
        </div>
        
        <div>
          <Label htmlFor="market">Market</Label>
          <Input
            id="market"
            value={formData.market}
            onChange={(e) => handleInputChange('market', e.target.value)}
            placeholder="e.g., Yes, No"
          />
        </div>
        
        <div>
          <Label htmlFor="marketplace">Market Coverage</Label>
          <Input
            id="marketplace"
            value={formData.marketplace}
            onChange={(e) => handleInputChange('marketplace', e.target.value)}
            placeholder="e.g., Local, Local and International"
          />
        </div>
        
        <div>
          <Label htmlFor="localMarket">Local Market</Label>
          <Input
            id="localMarket"
            value={formData.localMarket}
            onChange={(e) => handleInputChange('localMarket', e.target.value)}
            placeholder="e.g., Within the province, Outside the province"
          />
        </div>
        
        <div>
          <Label htmlFor="international">International</Label>
          <Input
            id="international"
            value={formData.international}
            onChange={(e) => handleInputChange('international', e.target.value)}
            placeholder="e.g., US, Canada, Australia"
          />
        </div>
      </div>
    </div>
  );
}

ProcessorStep4Marketing.propTypes = {
  formData: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  productTypes: PropTypes.array,
  newProduct: PropTypes.string,
  setNewProduct: PropTypes.func,
  addProduct: PropTypes.func,
  removeProduct: PropTypes.func,
};
